var map = {
	"./marker-bushfires.svg": "9NuM",
	"./marker-crashes.svg": "lJ0U",
	"./marker-false-alarms.svg": "cKbP",
	"./marker-other-fires.svg": "2nS3",
	"./marker-rescues.svg": "cPG6",
	"./marker-rfa.svg": "Uxp7",
	"./marker-structure-fires.svg": "A1nR"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iXc8";